import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { PATHS } from '@/common';
import { TAX_FORMS_LIST_KEY } from '@/modules/investments/TaxForms/queries/useTaxFormsList.query';

export interface ExcessContributionWithdrawPayload {
  employee_id: number;
  account_id: number;
  amount: number;
  excess_earnings: number;
  payment_method_id: number;
  file_url?: string;
}

export interface ExcessContributionWithdrawResponse {
  excess_contribution_id: number;
}

export const useCreateExcessContributionQuery = (onSuccess?: () => void, onError?: (errorMessage?: string) => void) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (payload: ExcessContributionWithdrawPayload) =>
      api.post<ExcessContributionWithdrawResponse>(PATHS.CREATE_EXCESS_CONTRIBUTION, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [TAX_FORMS_LIST_KEY],
        });
        onSuccess?.();
      },
      onError: (error) => {
        const errorMessage = _.get(error, 'response.data.elevate_error_message', '') as string;
        onError?.(errorMessage);
      },
    }
  );

  return {
    create: mutateAsync,
    isLoading,
    isError,
    isSuccess,
  };
};
